import { FluxStandardAction } from "../../../__utils/type";
import * as Actions from "../../../constants/actions";

export const setShareCalculatorConfig = (data: any): FluxStandardAction => {
    return {
        type: Actions.SET_SHARE_CALCULATOR_CONFIG,
        payload: data
    }
};
export const setShareCalculatorCustomerDetails = (data: any,show:boolean): FluxStandardAction => {
    return {
        type: Actions.SET_SHARE_CALCULATOR_CUSTOMER_DETAILS,
        payload: {data: data,show:show}
    }
};
export const shareCalculatorViaWhatsapp = (data: boolean): FluxStandardAction => {
    return {
        type: Actions.SHARE_CALCULATOR_VIA_WHATSAPP,
        payload: data
    }
};
export const setCustomerFromSharedLinkDetails = (data: FluxStandardAction) => {
    return {
        type: Actions.SET_CUSTOMER_FROM_SHARED_LINK_DETAILS,
        payload: data
    }
};

export const setSIPlumsumCalculatorFormChanges = (data: FluxStandardAction) => {
    return {
        type: Actions.SET_SIP_LUMPSUM_CALCULATOR_FORM_CHANGES,
        payload: data
    }
};
